import { ASSETS } from "./shared";

const dogs = [
  {
    id: "otis-lola",
    name: "Otis & Lola",
    img: ASSETS.dogOtisLola,
    alt: "Therapy dogs Otis and Lola cuddling on the couch",
  },
  {
    id: "baylee",
    name: "Baylee",
    img: ASSETS.dogBaylee,
    alt: "Therapy dog Baylee lying on a blanket",
  },
];

export const TherapyDogs = () => (
  <section
    data-testid="therapy-dogs-section"
    className="py-20 md:py-28 px-6 md:px-12 max-w-6xl mx-auto border-t border-[#3B2760]"
  >
    <span className="mono-lbl text-xs text-[#FF2E88] uppercase font-bold">Four-Legged Team</span>
    <h2 className="display-type text-3xl md:text-5xl font-bold uppercase mt-2 mb-12">
      Meet the Therapy Dogs
    </h2>
    <div className="grid sm:grid-cols-2 gap-6 max-w-3xl">
      {dogs.map((d) => (
        <div
          key={d.id}
          data-testid={`therapy-dog-${d.id}`}
          className="bg-[#26153F] rounded-2xl border border-[#3B2760] overflow-hidden group"
        >
          <div className="aspect-square overflow-hidden">
            <img
              src={d.img}
              alt={d.alt}
              loading="lazy"
              className="card-img w-full h-full object-cover"
            />
          </div>
          <div className="p-6 flex items-baseline justify-between">
            <p className="font-bold text-lg">{d.name}</p>
            <p className="mono-lbl text-xs uppercase text-[#FF2E88] font-bold">Therapy Dog</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
